import React, { useEffect, useRef, useState } from "react";
import { Badge, Card, Dropdown, Table } from "react-bootstrap";
import Spinner from "../components/Common/Spinner";
import Pagination from "../components/Common/Pagination";
import PageTitle from "../layouts/PageTitle";
import { useNavigate } from "react-router-dom";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import ReasonModal from "../components/Modal/ReasonModal";
import FullImage from "../components/Modal/FullImage";
import {
  approveMultiRequest,
  approveRejectRequest,
  getProfileImageVerificationRequests,
  getVerificationRequests,
} from "../../services/UserServices/UserService";
import dummmyImg from "../../images/profile/images.jpeg";
import { text } from "@fortawesome/fontawesome-svg-core";
import DisplayDeleteMessage from "../components/Modal/DisplayDeleteMessage";
import {
  genderFilterPost,
  isRejectedPost,
} from "../../store/actions/FilterActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CountryPicker from "../components/Modal/CountryPicker";

export default function ReuploadProfile() {
  const dispatch = useDispatch();
  const location = useLocation();
  const locationFilter = useSelector((state) => state.filter.filter.location);
  const rejectedValue = useSelector(
    (state) => state.filter.filter.isRejectedValue
  );
  const genderFilter = useSelector((state) => state.filter.filter.gender);
  const [selectedCountry, setSelectedCountry] = useState(locationFilter);

  const [loader, setLoader] = useState(false);
  const [status, setStatus] = useState("reupload");
  const [gender, setGender] = useState(genderFilter);
  const [requests, setRequests] = useState([]);
  const [listLength, setListLength] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    location?.state?.page ? location?.state?.page : 0
  );
  const [order, setOrder] = useState("mostRecent");
  const [isRejected, setIsRejected] = useState(rejectedValue);
  const [initialFetch, setInitialFetch] = useState(true);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [id, setId] = useState("");
  const [type, setType] = useState("image");
  const imgBaseURl = "";
  const [imageForView, setImageForView] = useState("");
  const [view, setView] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [limit, setLimit] = useState(50);
  const navigate = useNavigate();
  const [selectedIds, setSelectedIds] = useState([]);
  const chackbox = document.querySelectorAll(".custom-checkbox input");
  const motherChackBox = document.querySelector("#checkbox1_exam_all");
  const mainCheckBox = useRef();
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  //   console.log(selectedIds,"selectedIds")
  const chackboxFun = (type) => {
    // console.log(motherChackBox, "type");

    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };
  function handleSelectedId(data) {
    // console.log(id," id select")
    const oldData = selectedIds.find((item) => {
      return item == data;
    });
    if (oldData === undefined) {
      setSelectedIds([...selectedIds, data]);
    } else {
      let updatedArr = selectedIds.filter((item) => item !== data);
      console.log(updatedArr, " id removed");
      setSelectedIds([...updatedArr]);
    }
    console.log(oldData, "new id......");
  }

  function handleAllId() {
    const allId = requests?.map((item) => {
      return item;
    });
    if (mainCheckBox?.current?.checked) {
      setSelectedIds([...allId]);
    } else {
      setSelectedIds([]);
    }
  }
  const fetchRequests = async () => {
    setLoader(true);
    try {
      const response = await getProfileImageVerificationRequests(
        currentPage,
        limit,
        isRejected,
        // type,
        // status,
        gender,
        order,
        selectedCountry
      );
      setRequests(response.data.data?.users);
      const total = response.data.data.count;
      setPageCount(Math.ceil(total / limit));
      setListLength(total);
      setLoader(false);
      setInitialFetch(false);
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
    }
  };

  const onApprove = async (id) => {
    setLoader(true);
    try {
      const payload = { userId: id, type: type, status: "accepted" };
      const response = await approveRejectRequest(payload);
      fetchRequests();
      notifyTopRight(response.data?.message);
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };
  const onMultiApprove = async (id) => {
    setLoader(true);
    try {
      // Extract only _id from selectedIds
      const userIds = selectedIds.map((item) => item._id);
      const payload = { userIds }; // Create payload with just _id array
      const response = await approveMultiRequest(payload);
      setSelectedIds([]);
      fetchRequests();
      notifyTopRight(response.data?.message);
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, [currentPage, type, limit,selectedCountry]);

  let timeoutId;
  const debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const debouncedHandleFetch = debounce(fetchRequests, 500);
  useEffect(() => {
    if ((status, gender, order, isRejected)) {
      fetchRequests();
    }
  }, [status, gender, order, isRejected]);

  useEffect(() => {
    if (initialFetch === false) {
      setCurrentPage(0);
      debouncedHandleFetch();
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, []);

  const handleImage = (text) => {
    console.log(text);
    setIsExpanded(true);
    setDeleteMessage(text);
  };

  const handleOpenInNewTab = (id) => {
    const url = `/user-details?data=${id}`;
    window.open(url, "_blank");
  };

  return (
    <div>
      <Card>
        <Card.Header>
          {" "}
          <div></div>
          <div className="d-flex gap-2 flex-grow-1 align-items-end">
            <div className="mb-2 mb-md-0 w-100">
              <label className="text-black font-w600 fs-14">
                Filter by Gender
              </label>

              <select
                className="form-control"
                value={gender}
                onChange={(e) => {
                  setGender(e.target.value);
                  dispatch(genderFilterPost(e.target.value));
                }}
              >
                <option value={"all"}>All</option>
                <option value={"male"}>Male</option>
                <option value={"female"}>Female</option>
                <option value={"member"}>Member</option>
                <option value={"pastMember"}>Past Member</option>
                <option value="hideProfile">Hide Profile</option>
              </select>
            </div>
            <div className="mb-2 mb-md-0 w-100">
              <label className="text-black font-w600 fs-14">Location</label>
              <CountryPicker
                selectedCountry={selectedCountry}
                setSelectedCountry={setSelectedCountry}
                onSelect={(name) => setSelectedCountry(name)}
              />
            </div>
            <div className="mb-2 mb-md-0 w-100">
              <label className="text-black font-w600 fs-14">
                Filter by Order
              </label>
              <select
                className="form-control"
                value={order}
                onChange={(e) => setOrder(e.target.value)}
              >
                <option value={"all"}>All</option>
                <option value={"mostRecent"}>Most Recent</option>
              </select>
            </div>
            <div className="mb-2 mb-md-0 w-100">
              <label className="text-black font-w600 fs-14">
                Delete Profile Re upload
              </label>
              <select
                className="form-control"
                value={isRejected}
                onChange={(e) => {
                  setIsRejected(e.target.value);
                  dispatch(isRejectedPost(e.target.value));
                }}
              >
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
            {selectedIds?.length > 0 && (
              <div className="mb-2 mb-md-0 w-100 text-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => onMultiApprove()}
                >
                  Approve
                </button>
              </div>
            )}
          </div>
        </Card.Header>
        <Card.Body className="pb-0 pt-3">
          {loader ? (
            <Spinner />
          ) : (
            <div className="row">
              {requests?.map((item, i) => (
                <div
                  className="col-md-3 col-sm-6 col-6  mb-4"
                  key={i}
                  onClick={() => handleOpenInNewTab(item?._id)}
                >
                  <div
                    className="position-relative rounded overflow-hidden shadow-sm pointer"
                    style={{
                      height: "330px",
                      backgroundColor: "#222",
                    }}
                  >
                    {/* IMAGE */}
                    <img
                      src={
                        item?.images[0]?.url
                          ? imgBaseURl + item?.images[0]?.url
                          : dummmyImg
                      }
                      alt="profile"
                      className="w-100 h-100"
                      style={{ objectFit: "cover" }}
                    />

                    {/* TOP RIGHT HIDE BADGE */}
                    {item?.hideProfile && (
                      <span
                        className="position-absolute top-0 end-0 m-2 badge bg-danger"
                        style={{ zIndex: 5 }}
                      >
                        Hide
                      </span>
                    )}

                    {/* GRADIENT */}
                    <div
                      className="position-absolute bottom-0 start-0 w-100"
                      style={{
                        height: "40%",
                        background:
                          "linear-gradient(0deg, rgba(0,0,0,0.9), transparent)",
                      }}
                    ></div>

                    {/* TEXT OVERLAY */}
                    <div
                      className="position-absolute bottom-0 text-white p-2"
                      style={{ zIndex: 5 }}
                    >
                      {/* NAME + AGE */}
                      <div className="fw-bold fs-6">
                        {item?.name}, {item?.age}
                      </div>

                      {/* GENDER */}
                      <div
                        className="text-white"
                        style={{ fontSize: "13px" }}
                      >
                        {item?.gender &&
                          item?.gender.charAt(0).toUpperCase() +
                            item?.gender.slice(1)}{" "}({item?.actualCountry})
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* No Data */}
          {requests?.length === 0 && !loader && (
            <div className="justify-content-center d-flex my-5">
              Sorry, Data Not Found!
            </div>
          )}

          {/* Pagination */}
          {requests?.length !== 0 && (
            <div className="card-footer clearfix">
              <div className="d-block d-sm-flex justify-content-between align-items-center">
                <div className="dataTables_info">
                  Showing {currentPage * limit + 1} to{" "}
                  {listLength > (currentPage + 1) * limit
                    ? (currentPage + 1) * limit
                    : listLength}{" "}
                  of {listLength} entries
                </div>
                <Pagination
                  pageCount={pageCount}
                  pageValue={currentPage}
                  setPage={setCurrentPage}
                  setLimit={setLimit}
                  limit={limit}
                />
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
      {showRejectModal && (
        <ReasonModal
          show={showRejectModal}
          id={id}
          type={type}
          table={fetchRequests}
          onHide={() => setShowRejectModal(false)}
        />
      )}
      {isExpanded && (
        <DisplayDeleteMessage
          show={isExpanded}
          text={deleteMessage}
          onHide={() => setIsExpanded(false)}
        />
      )}
      {view && (
        <FullImage
          show={view}
          image={imageForView}
          onHide={() => setView(false)}
          imageType={"image"}
        />
      )}
    </div>
  );
}
